import type { PropsWithChildren } from 'react';
import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { Modal } from '@garnish/overlays';

export const FooterLayout = (props: PropsWithChildren) => {
  return <Modal.Footer style={styles.footer}>{props.children}</Modal.Footer>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    borderTopColor: theme.colors.DARK_KALE,
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: Platform.select({
      ios: 0,
      default: theme.spacing['4'],
    }),
  },
});
